if (typeof Array.prototype.find === 'undefined') {
  Array.prototype.find = function(callback, thisArg) {
    for (var i = 0; i < this.length; i++) {
      if (callback.call(thisArg || window, this[i], i, this)) return this[i];
    }
    return undefined;
  };
}
